var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-data"},[_c('div',{ref:"charts",staticStyle:{"width":"712px","height":"490px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }